module.exports = __webpack_public_path__ + "static/img/7.ae9d385.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/imgs/7.png
// module id = NR27
// module chunks = 0